<template>
  <md-card class="md-card-profile">
    <div class="md-card-avatar">
      <img
        src="../../assets/img/faces/datacenter.jpg"
        alt="Corredor de um datacenter com vários servidores ao redor"
      >
    </div>

    <md-card-content>
      <h6 class="category text-gray">
        Datacenter
      </h6>
      <h4 class="card-title">
        {{ entity.name }}
      </h4>
      <div
        v-if="shouldShowDescription"
        class="card-description"
      >
        <div>{{ entity.address }}</div>
        <div>{{ entity.town }} - {{ entity.state }}</div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import {getUserSession} from "../../_services/localstorage";
import {EventBus, events} from "../../_helpers/event-bus";
import { getEntityById } from "@/_services/entity.service";

export default {
  name: "EntityCard",
  data() {
    return {
      entity: {},
    };
  },
  computed: {
    shouldShowDescription() {
      return this.entity && this.entity.address && this.entity.town && this.entity.state;
    }
  },
  async created() {
    await this.loadInformation();

    EventBus.$on(events.CHANGED_ENTITY, this.loadInformation);
  },
  beforeDestroy() {
    EventBus.$off(events.CHANGED_ENTITY, this.loadInformation);
  },
  methods: {
    async loadInformation() {
      this.user = getUserSession();

      this.entity = await getEntityById(this.user.activeentity);
    }
  }
};
</script>
